import React from 'react';
import T from 'prop-types';

import skeletons from './Skeletons';
import Tooltip from '../../../Tooltip';
import AppIcon from '../../../AppIcon';
import Button from '../../../Buttons/Button';
import QuickViewCloseButton from '../../QuickViewCloseButton';
import DataStrengthIndicator from '../../../../pages/company-page-v2/components/CompanyHeader/DataStrengthIndicator';

import { handleCleanupRequests } from '../../actions';
import helpers, { truncateTicker } from '../../../../utils/helpers';

const Header = ({
  companyData,
  settings,
  showDataStrengthIndicator,
  onClose,
}) => {
  const companyPageLink = `${window.location.origin}/companies/${companyData.ref_no}`;
  const companyName = helpers.decodeEntities(companyData.name);

  const renderDataStrengthIndicator = () => {
    if (settings.pending) return skeletons.dataStrengthIndicator;
    if (settings.error || !companyData?.bloomberg_ticker || !companyData?.correlation_status) {
      return null;
    }

    return (
      <DataStrengthIndicator
        strength={companyData?.correlation_status?.toLowerCase()}
        hideTooltip
      />
    );
  };

  return (
    <div className="company-quick-view-header">
      <div className="company-quick-view-header__main-info">
        {settings.pending ? skeletons.header.metaContainer : (
          <div className="company-meta-container">
            <AppIcon
              alt={companyData.name}
              url={companyData.icon_url}
              size={50}
              defaultBrokenNoStoreIcon="hicon-company-fill"
              containerClasses="company-icon-container"
            />

            <div className="company-meta-container__right">
              <Tooltip content={companyName}>
                <h2 className="h2 text-truncate">{companyName}</h2>
              </Tooltip>
              <div className="company-meta-container__badges">
                {companyData.bloomberg_ticker && (
                  <div className="company-ticker-badge">
                    {truncateTicker(companyData.bloomberg_ticker)}
                  </div>
                )}
                {showDataStrengthIndicator && renderDataStrengthIndicator()}
              </div>
            </div>
          </div>
        )}

        <div className="company-quick-view-header__actions">
          <QuickViewCloseButton
            onClose={onClose}
          />
        </div>
      </div>
      <div className="company-quick-view-header__view-btns">
        {settings.pending ? skeletons.header.companyPageLink : (
          <Button
            className="view-company-btn"
            href={companyPageLink}
            onClick={handleCleanupRequests}
          >
            View Company
          </Button>
        )}
      </div>
    </div>
  );
};
Header.propTypes = {
  companyData: T.object.isRequired,
  settings: T.shape({
    pending: T.bool,
    error: T.bool,
  }).isRequired,
  showDataStrengthIndicator: T.bool,
  onClose: T.func.isRequired,
};

export default Header;
